import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, ArrowRight } from 'lucide-react';

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_hospital-bess-losung/artifacts/jjx32oil_Hospital%20BESS-2.svg";

export const Footer = ({ onContactClick }) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    solutions: [
      { name: 'Wirtschaftlichkeit', path: '/wirtschaftlichkeit' },
      { name: 'Anwendungsfälle', path: '/anwendungsfaelle' },
      { name: 'Technologie', path: '/technologie' },
      { name: 'Prozess', path: '/prozess' },
    ],
    company: [
      { name: 'Über uns', path: '/ueber-uns' },
      { name: 'FAQ', path: '/faq' },
    ],
  };

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      {/* CTA Section */}
      <div className="border-b border-slate-700">
        <div className="container-main py-12 lg:py-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl lg:text-3xl font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Bereit für die Energiewende?
              </h3>
              <p className="text-slate-400">
                Lassen Sie uns gemeinsam Ihr Einsparpotenzial analysieren.
              </p>
            </div>
            <button
              onClick={onContactClick}
              className="flex items-center gap-2 bg-[#10B981] hover:bg-emerald-600 text-white px-8 py-4 rounded-md font-medium transition-all"
              data-testid="footer-cta-btn"
            >
              Kostenlose Erstberatung
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-main py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-4" data-testid="footer-logo">
              <img 
                src={LOGO_WHITE} 
                alt="Hospital-BESS" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm mb-6">
              Hospital-BESS – Ihr Partner für Batteriespeicherlösungen im Gesundheitswesen. 
              Wirtschaftlich, zuverlässig, zukunftssicher.
            </p>
            <div className="flex gap-3">
              <a 
                href="#" 
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-slate-700 transition-colors"
                data-testid="linkedin-link"
              >
                <Linkedin className="w-5 h-5 text-slate-400" />
              </a>
            </div>
          </div>

          {/* Solutions Links */}
          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Lösungen
            </h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                    data-testid={`footer-link-${link.path.replace('/', '')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Unternehmen
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                    data-testid={`footer-link-${link.path.replace('/', '')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-slate-500 flex-shrink-0" />
                <div className="text-slate-400 text-sm">
                  <a href="tel:+4917693127245" className="hover:text-white transition-colors block">+49 176 93127245</a>
                  <a href="tel:+493071047955" className="hover:text-white transition-colors block">+49 30 71047955</a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-slate-500 flex-shrink-0" />
                <a href="mailto:info@hospital-bess.de" className="text-slate-400 hover:text-white text-sm transition-colors">
                  info@hospital-bess.de
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} Hospital-BESS. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/datenschutz" className="text-slate-500 hover:text-slate-400 text-sm transition-colors">
              Datenschutz
            </Link>
            <Link to="/impressum" className="text-slate-500 hover:text-slate-400 text-sm transition-colors">
              Impressum
            </Link>
            <Link to="/barrierefreiheit" className="text-slate-500 hover:text-slate-400 text-sm transition-colors">
              Barrierefreiheit
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
